export default __webpack_public_path__ + "static/media/session2.87f94d6c.svg";